// extracted by mini-css-extract-plugin
export default {"schoolInformation":"KWuze","addressLine":"SUdYM","selectedSchool":"K9xPe","noProjects":"w-A-K","schoolButtons":"rA4Ey"};